import { EmployeeModel } from './EmployeeModel'

export class CompanyManagerModel extends EmployeeModel {}
